module.exports = __webpack_public_path__ + "static/media/alb_blog_logo.e46d8555.png";